<template>
  <index :status="estatusSolcitud" />
</template>

<script>
import Index from './Index.vue'

export default {
  name: 'RechazadosPrebecarios',
  components: {
    Index,
  },
  data() {
    return {
      estatusSolcitud: 3,
    }
  },
}
</script>
